export default {
  watch: {
    // Watch for error changes
    // Note, there's a bug with v-validate where newErr and oldErr are always the same;
    // That is, both variables represent the current (or newErr) value
    // Note as well, I'm not actually using this anymore
    'errors.items': function (newErr) {
      this.parentForm.$emit('field:errors-updated', newErr, this.name)
    },
    // Watch value changes
    'value': function (newVal, oldVal) {
      this.parentForm.$emit('field:changed', this.name, newVal, oldVal)
    },
    'fieldId': function (newVal, oldVal) {
      this.parentForm.$emit('field:id-changed', this.name, newVal, oldVal)
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/watch.js